angular.module('wbControllers').controller('UserDashboardController',
  ['$scope', '$rootScope', '$resource', '$q', 'users', 'CurrentUserPartnerChannel', 'locale', 'AccountApplication', 'FinancialPlan', 'Dashboard', 'History', '$routeParams', '$window', 'SendEbookOfferCodeEmail', 'Profile','TransfersRestrictedDetails',
    function ($scope, $rootScope, $resource, $q, users, CurrentUserPartnerChannel, locale, AccountApplication, FinancialPlan, Dashboard, History, $routeParams, $window, SendEbookOfferCodeEmail, Profile, TransfersRestrictedDetails) {
      this.accountApplications = AccountApplication.query($routeParams);
      this.financialPlans = FinancialPlan.query($routeParams);
      this.hasExternalAdvisor = $window.currentUser.hasExternalAdvisor;

      this.accounts = [];
      this.hisaAccounts = [];
      this.allAccounts = [];
      this.userHasAccounts = false;
      this.canCreateHISA = false;
      this.hisaRate = null;
      this.disableAccountOpeningTooltipPath = (locale.isFrench() ? 'https://help.cidirectinvesting.com/fr_FR/account-opening/suspension-temporaire-des-demandes-de-nouveaux-comptes-pour-les-nouveaux-clients' : 'https://help.cidirectinvesting.com/en_US/opening-an-account/temporary-suspension-of-new-account-applications-for-new-clients');

      this.isFrench = locale.isFrench();

      this.displayWarning = false;
      this.warningCopy = undefined;
      this.warningCtas = undefined;

      this.investmentAccountOpeningRestricted = false;
      this.investmentAccountOpeningRestrictedCopy = undefined;
      this.investmentAccountOpeningRestrictedCtas = undefined;

      this.savingsAccountOpeningRestricted = false;
      this.savingsAccountOpeningRestrictedCopy = undefined;
      this.savingsAccountOpeningRestrictedCtas = undefined;

      $scope.showRestrictionsDialogCloseText = true;

      this.accountApplicationPath = $window.process.env.ACCOUNT_APPLICATION_PATH;
      this.view = 'performance';

      // Get and assign the various config variables from config#show
      const configVariables = $resource('/api/config', {});
      configVariables.get().$promise.then((configs) => {
        this.hisaRate = (configs.rates.hisa_rate / 100);
      });

      const dashboardWarningDetails = $resource('/api/warnings/dashboard');
      dashboardWarningDetails.get().$promise
        .then((details) => {
          this.displayWarning = details.display_warning;
          this.warningCopy = details.copy;
          this.warningCtas = details.ctas;
        })
        .catch(()=> { console.error('Failed to fetch dashboard warning details.') });

      const accountOpeningRestrictionDetails = $resource('/api/restrictions/account-opening')
      accountOpeningRestrictionDetails.get().$promise
      .then((details) => {
        this.investmentAccountOpeningRestricted = details.investment_account_opening_restricted;
        this.investmentAccountOpeningRestrictedCopy = details.investment_account_copy;
        this.investmentAccountOpeningRestrictedCtas = details.investment_account_ctas;

        this.savingsAccountOpeningRestricted = details.savings_account_opening_restricted;
        this.savingsAccountOpeningRestrictedCopy = details.savings_account_copy;
        this.savingsAccountOpeningRestrictedCtas = details.savings_account_ctas;
      })
      .catch(()=> { console.error('Failed to fetch account opening restrictions details.') });

      this.openAccountHandler = () => {
        if (!this.investmentAccountOpeningRestricted && !this.savingsAccountOpeningRestricted) {
          $window.location.href = this.accountApplicationPath;
        } else if (this.investmentAccountOpeningRestricted && this.savingsAccountOpeningRestricted) {
          $scope.investmentAccountOpeningRestrictedDialog.show();
        } else {
          $scope.disableAccountOpeningDialog.show();
        }
      };

      this.openInvestmentHandler = () => {
        if (!this.investmentAccountOpeningRestricted) {
          $window.location.href = '/account-applications/new';
        } else if (this.investmentAccountOpeningRestricted) {
          $scope.investmentAccountOpeningRestrictedDialog.show();
        } else {
          $scope.disableAccountOpeningDialog.show();
        }
      };

      this.openHisaHandler = () => {
        if (!this.savingsAccountOpeningRestricted) {
          $window.location.href = '/app/client/account_application/hisa';
        } else if (this.savingsAccountOpeningRestricted) {
          $scope.savingsAccountOpeningRestrictedDialog.show();
        } else {
          $scope.disableAccountOpeningDialog.show();
        }
      };

      TransfersRestrictedDetails.get().$promise.then((restrictionsDetails) => {
        this.accountTransfersRestricted = restrictionsDetails.accountTransfers.accountTransfersRestricted;
        this.accountTransfersRestrictedCopy = restrictionsDetails.accountTransfers.accountTransfersCopy;
        this.accountTransfersRestrictedCtas = restrictionsDetails.accountTransfers.accountTransfersCtas;

        this.depositsRestricted = restrictionsDetails.deposits.depositsRestricted;
        this.depositsRestrictedCopy = restrictionsDetails.deposits.depositsCopy;
        this.depositsRestrictedCtas = restrictionsDetails.deposits.depositsCtas;

        this.withdrawalsRestricted = restrictionsDetails.withdrawals.withdrawalsRestricted;
        this.withdrawalsRestrictedCopy = restrictionsDetails.withdrawals.withdrawalsCopy;
        this.withdrawalsRestrictedCtas = restrictionsDetails.withdrawals.withdrawalsCtas;

        // all transfer types restricted
        if (this.accountTransfersRestricted && this.depositsRestricted && this.withdrawalsRestricted) {
          this.transfersRestricted = true;
          this.transfersRestrictedCopy = this.accountTransfersRestrictedCopy;
          this.transfersRestrictedCtas = this.accountTransfersRestrictedCtas
        }
      });

      this.transferFundsHandler = () => {
        if (this.transfersRestricted) {
          $scope.transfersRestrictedDialog.show();
          return;
        }

        $window.location.href = '/app/transfers/new'
      }

      this.replaceMessageWithHyperlink = (message, searchRegex, englishLink, frenchLink) => {
        const regex = new RegExp(searchRegex);
        const hyperlink = this.isFrench ? frenchLink : englishLink;

        const newMessage = message.replace(regex, `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">$1</a>`);

        return newMessage;
      }

      // TODO: Rewrite this whole thing to use a single endpoint
      this.inceptionData = Dashboard.get($routeParams, (inceptionData) => {
        if (inceptionData === undefined) { return; }
        this.accountIds = _.map(inceptionData.accounts, 'id');
        this.user = inceptionData.user;
        this.setCanCreateHISA(inceptionData.canCreateHisa);
        this.parseAndSetAccounts(inceptionData.accounts);
        this.taskReminders = inceptionData.taskReminders;
        this.holdings = [];
        this.pieChartData = inceptionData.assetClassAllocation;
        if (!_.some(inceptionData.positions)) { return; }
        for (const position of inceptionData.positions) {
          const existingPosition = _.find(this.holdings, { symbol: position.symbol });
          if (existingPosition) {
            existingPosition.amount += parseFloat(position.quantity);
          } else {
            this.holdings.push({
              symbol: position.symbol,
              description: position.description,
              assetClass: position.assetClass,
              amount: parseFloat(position.quantity),
            });
          }
        }

        this.holdings = _.orderBy(this.holdings, 'amount', false);
      });

      $scope.$watch('ctrl.range', (range) => {
        if (range == null) { return; }
        this.loaded = false;

        // This would send a datetime with a timezone (which gets lost when we catch the response
        // in the API) and really we need it to just send the date relevant to the client's timezone
        // because the API is interpreting the datetime as UTC & its giving an artificial offset which
        // can make the start/end dates used to make the ROR period inconsistent depending on time of day.

        for (let key in range) {
          if (key === 'startDate' || key === 'endDate') {
            // mutate datetime with timezone to date as of user's local browser.
            range[key] = moment(range[key]).format('YYYY-MM-DD')
          }
        }

        this.hideDetails();
        Dashboard.get(_.merge($routeParams, range), (d) => {
          this.dashboard = d;
          this.loaded = true;
        });

        History.query(_.merge($routeParams, range, { cad: true }), (history) => {
          history.forEach(d => d.date = moment(d.date));
          this.history = history;
        });
      });

      this.hasPlansEnabled = $window.process ? $window.process.env.FEATURE_FINANCIAL_PLANS !== 'false' : true;
      this.hasToolsEnabled = $window.process ? $window.process.env.FEATURE_TOOLS !== 'false' : true;
      this.hasBlogEnabled = $window.process ? $window.process.env.FEATURE_BLOG !== 'false' : true;
      this.getBrandName = () => {
        let name = 'CI Direct Investing';
        if ($window.process && $window.process.env && $window.process.env.WHITELABEL_FULL_NAME) {
          name = $window.process.env.WHITELABEL_FULL_NAME;
        }
        return name;
      };

      this.showROR = balance => balance > 0;

      this.hasFundedAccount = () => {
        if (this.accounts && this.accounts.length > 0) {
          let total = 0;
          this.accounts.forEach((acc) => {
            if (acc.endingBalance) { total += acc.endingBalance; }
          });

          return total > 0;
        } else {
          return false;
        }
      }

      // Check if wealthie client initial onboarding
      CurrentUserPartnerChannel.get((data) => {
        this.isWealthieClient = data.partnerChannel === 'wealthie';
      });

      this.displayHISASection = () => (this.hisaAccounts.length || this.canCreateHISA) && !this.isWealthieClient;

      this.setCanCreateHISA = (canCreateHisa) => {
        if (!canCreateHisa || canCreateHisa.error) {
          this.canCreateHISA = false;
        } else {
          this.canCreateHISA = true;
        }
      }

      this.accountApplications.$promise.then(response => {
        this.applicationPending = !!response.find(app => app.status === 'incomplete')
      })

      this.sendEmailConfirmation = () => {
        this.emailConfirmationSuccess = false;
        this.emailConfirmationFailed = false;
        return users.sendEmailConfirmation()
      .then(() => (this.emailConfirmationSuccess = true))
      .catch(() => (this.emailConfirmationFailed = true));
      };

      this.cancelApplication = (app) => {
        if (app) {
          AccountApplication.delete({ id: app.id }, () => {
            _.remove(this.accountApplications, a => a.id === app.id);
          });
        }
      };

      this.parseAndSetAccounts = (accounts) => {
        if (!accounts || accounts.length === 0) { return false; };

        this.accounts = this.parseNonHISA(accounts);
        if (this.accounts.length > 0) { this.userHasAccounts = true; };

        this.hisaAccounts = this.parseHISA(accounts);
        this.allAccounts = accounts;
      };

      this.parseNonHISA = (accounts) => {
        return accounts.filter((acc) => { return acc.accountType !== 'hisa'; });
      };

      this.parseHISA = (accounts) => {
        return accounts.filter((acc) => { return acc.accountType === 'hisa'; });
      };

      this.handleReminderDismiss = (reminder) => {
        if (reminder.dismissalInProgress) return;
        reminder.dismissalInProgress = true;
      
        const currentUser = users.getCurrentUser();
      
        let userId = currentUser.id;
        if (currentUser.roles.includes('staff')) {
          userId = $routeParams.userId
        }
        Profile.dismissReminder({ user_id: userId, reminder_id: reminder.id }).$promise.then(() => {
          this.taskReminders = this.taskReminders.filter(o => o.id !== reminder.id);
        }, () => {
          reminder.dismissalInProgress = false;
        });
      }

  // Chart Details Related
      $scope.$on('chartClicked', (e, details) => {
        this.chartDetails = details;
        this.selectedTab = 'details';
      });

      $scope.$on('overlayHidden', (e) => {
        this.chartDetails = undefined;
        this.selectedTab = 'performance';
      });

      let hidingDetails = false;
      this.showDetails = () => {
        if (!hidingDetails) { this.selectedTab = 'details'; }
        return hidingDetails = false;
      };

      this.hideDetails = () => {
        this.chartDetails = undefined;
        this.selectedTab = 'performance';
        hidingDetails = true;
        $scope.$broadcast('detailsHidden');
      };

      $scope.handleSendOfferCodeEmail = () => {
        const currentUser = users.getCurrentUser();
        // exclude any staff user click the button
        if (!Object.values(currentUser.roles).includes("staff")) {
          SendEbookOfferCodeEmail.sendEbookOfferCodeEmail({ email: currentUser.email, id: currentUser.id});
          $scope.closeEmailSentDialog.show();
        }
      };

      this.closeEmailSentDialog = () => {
        $scope.closeEmailSentDialog.hide()
        $window.location.reload();
      };

      return this;
    },
  ]);
